window.arCurriculumVitaeWorkExperienceDetailFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += row.description;
    }
    return html;
}
